import React, { Fragment } from 'react';
import { UserInfo } from '../../../../types';
import { NavDropdownItem } from '../NavDropdownItem';
import { ProfileMenuDropdown } from './ProfileMenuDropdown';

export interface ProfileMenuProps {
  userInfo: UserInfo;
  dropdownItems: ProfileMenuDropdownItem[];
}

export interface ProfileMenuDropdownItem {
  name: string;
  path: string;
  onClick?: (e?: any) => void;
}

export const ProfileMenu = ({ userInfo, dropdownItems }: ProfileMenuProps) => (
  <ProfileMenuDropdown userInfo={userInfo}>
    {dropdownItems.map((item, idx) => (
      <Fragment key={`${item.name}-${idx}`}>
        <div className='h-0 border border-t-0 border-gray-900 border-solid opacity-25' />
        <NavDropdownItem name={item.name} path={item.path} {...(item.onClick ? { onClick: item.onClick } : {})}>
          {item.name}
        </NavDropdownItem>
      </Fragment>
    ))}
  </ProfileMenuDropdown>
);
